import { Box, HStack, Radio, Text, useClipboard } from '@chakra-ui/react';
import React from 'react';
import { FieldArrayWithId, useFormContext } from 'react-hook-form';

import { TypeUtils } from '../../../../../../framework/utils/UtilityTypes';
import StyledButton from '../../../../../components/StyledButton';
import { FormSelectProps, useFormItems } from '../../../../../hooks/formItems';
import useToastHook from '../../../../../hooks/ToastHook';
import { MasterKey } from '../../../../../models/gen/masterKey';
import { UserSummary } from '../../../../../models/gen/userSummary';
import { useMasterContext } from '../../../../MasterProvider';
import { useSizeContext } from '../../../../SizeProvider';
import { WorkerAssignmentFormState } from './FormArea';

/**
 *
 */
type FormAreaItemProps = {
  // assignWorkerId: number;
  field: FieldArrayWithId<WorkerAssignmentFormState, 'members', 'id'>;
  idx: number;
  member?: UserSummary;
  onChange: Runnable;
  options: FormSelectProps<WorkerAssignmentFormState>['options'];
  showLeaderRadio?: boolean;
};

/**
 *
 * @returns
 */
const FormAreaItem: React.FunctionComponent<FormAreaItemProps> = ({
  // assignWorkerId,
  field,
  idx,
  member,
  onChange,
  options,
  showLeaderRadio,
}) => {
  const sizes = useSizeContext();
  const master = useMasterContext();
  const form = useFormContext<WorkerAssignmentFormState>();
  const { FormSelect } = useFormItems(form);

  return (
    <HStack flexWrap="wrap">
      <Text fontSize={sizes.fontSize.modalBodyTitle}>
        {field.taskIds
          ?.map((taskId) => master.getBy(MasterKey.Tasks, taskId)?.name)
          .join('、') || '―'}
      </Text>
      <FormSelect
        mode="edit"
        name={`members.${idx}.userCodeMember`}
        options={options}
        selectProps={{ onChange: onChange }}
      />
      {showLeaderRadio && (
        <Radio
          isReadOnly={!showLeaderRadio}
          onChange={() => onChange()}
          value={field.assignWorkerId?.toString()}
        >
          職長
        </Radio>
      )}
      <ClipBoard {...member} />
    </HStack>
  );
};

type ClipBoardProps = {
  name?: string;
  tel?: string;
};

const generateSample = (name?: string, tel?: string) =>
  TypeUtils.isNonNilString(name)
    ? `${name} さん${TypeUtils.isNonNilString(tel) ? ` (${tel})` : ''}`
    : '';

const ClipBoard: React.FunctionComponent<ClipBoardProps> = ({ name, tel }) => {
  const [text, setText] = React.useState(generateSample(name, tel));
  const { onCopy, value } = useClipboard(text);
  const { toast } = useToastHook();

  React.useEffect(() => setText(generateSample(name, tel)), [name, tel]);

  return (
    <HStack
      justifyContent="space-between"
      marginTop="1 !important"
      maxWidth="calc(100% - 12px)"
    >
      <Text
        backgroundColor="gray.200"
        borderColor="gray.300"
        borderRadius="sm"
        borderWidth="1px"
        flexGrow={1}
        flexShrink={1}
        overflow="hidden"
        paddingX={2}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        width="calc(100vw - 124px)"
      >
        {value || '　'}
      </Text>
      <StyledButton
        flexGrow={0}
        flexShrink={0}
        isDisabled={TypeUtils.isNilString(value)}
        onClick={() => {
          onCopy();
          toast('クリップボードにコピーしました');
        }}
        paddingX="8px"
        size="xs"
        // width="67.78px"
      >
        Copy
      </StyledButton>
    </HStack>
  );
};

export default FormAreaItem;
